import { motion } from 'framer-motion';

export const SmallLoader = ({
    className,
    invertColors,
    progress
}: {
    className?: string;
    invertColors?: boolean;
    progress?: number;
}) => {
    const isDeterminate = progress !== undefined;
    const circumference = 56.5; // 2 * π * 9

    return (
        <svg className={`h-5 w-5 text-current ${className}`} width="24" height="24" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="9" stroke={invertColors ? "#323232" : "#EEEBEE"} strokeWidth="3" fill="none" />
            <motion.circle
                cx="12" cy="12" r="9"
                stroke={invertColors ? "#EEEBEE" : "#323232"}
                strokeWidth="3" strokeLinecap="round" fill="none"
                strokeDasharray={isDeterminate ? circumference : "14 42"}
                strokeDashoffset={isDeterminate ? circumference - (progress! / 100) * circumference : 0}
                animate={isDeterminate ? {} : { rotate: 360 }}
                transition={isDeterminate ? { duration: 0.3 } : { duration: 1, repeat: Infinity, ease: "linear" }}
                style={{ transformOrigin: "50% 50%", transform: isDeterminate ? "rotate(-90deg)" : undefined }}
            />
        </svg>
    );
};